class FacilityId {
  constructor(private readonly _value: number = Number.NaN) {
  }

  public equals(other: FacilityId): boolean {
    return this._value === other.value;
  }

  get value() {
    return this._value;
  }
}

export default FacilityId;
